import {Component} from "@angular/core";
import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";
import {AccountService} from "@supoui/core/auth/account.service";
import {PasswordChange} from "@supoui/core/user/password-change.model";
import {AbstractControl, FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";

@Component({
    selector: 'app-change-password-modal',
    templateUrl: './change-password-modal.component.html',
    styleUrls: ['./change-password-modal.component.scss'],
    standalone: false
})
export class ChangePasswordModalComponent {
  passwordForm: FormGroup;

  constructor(public activeModal: NgbActiveModal, private accountService: AccountService, private fb: FormBuilder) {
    this.passwordForm = this.fb.group({
      newPassword: new FormControl('', [Validators.required, Validators.minLength(8)]),
      confirmPassword: new FormControl('', [Validators.required])
    }, {
      validators: (form: AbstractControl) => {
        const error = form.get('newPassword').value !== form.get('confirmPassword').value ? {nolabel: 'global.messages.error.dontmatch'} : null;
        form.get('confirmPassword').setErrors(error);
        return error;
      }
    });
  }

  changePassword(): void {
    if (this.passwordForm.invalid || this.passwordForm.get('newPassword').value !== this.passwordForm.get('confirmPassword').value) {
      this.passwordForm.get('confirmPassword').setErrors( {nolabel: 'global.messages.error.dontmatch'});
      return;
    }
    const passwordChange = {'newPassword': this.passwordForm.value.newPassword} as PasswordChange;
    console.log('passwordChange: ', JSON.stringify(passwordChange));
    this.accountService.changePassword(passwordChange).subscribe(() => {
      this.activeModal.close();
    });
  }
}
